const config = {
  state: {
    routeFromPath: "",
    questionBackData: {},
  },
  mutations: {
    SET_ROUTE_FROM(state, path) {
      state.routeFromPath = path;
    },
    SET_QUESTION_BACK_DATA(state, data) {
      state.questionBackData = data;
    },
  },
};

export default config;
